// tslint:disable
import { IconLayer, TextLayer } from "@deck.gl/layers";
import { BaseLayerClusterGeoJSONDeck } from "../../common/layers/baseLayerClusterGeoJSONDeck";
import { LAYERS_ID, LAYERS_SQL, ICONS_BY_TYPE, LEVELS } from "./constants";
import { MvtService } from "../../common/services/mvt.service";
import Supercluster from "supercluster";
import { FilterSQL } from "../../common/utils";
import { HistoricPopupComponent } from "../historic-popup/historic-popup.component";
import { POI_TYPES } from './constants'
// tslint:enable

export class ClusterTrafficIntensityLayer extends BaseLayerClusterGeoJSONDeck {
  poisLayerSourceVisible = [];
  poisLayerTypeVisible = [];
  data = [];
  zoom = 11;
  layerData: any;
  icon: string;
  layers = {
    [LAYERS_ID.WAZE_BCN_TRAFFIC_INTENSITY_POIS_ICONS_LAYER_GEOJSON]: new IconLayer({
      id: LAYERS_ID.WAZE_BCN_TRAFFIC_INTENSITY_POIS_ICONS_LAYER_GEOJSON,
      iconAtlas: this.iconAtlas,
      iconMapping: this.iconMapping,
      sizeScale: 50,
      pickable: true,
      onClick: (e) => this._clickOnPoisLayer(e),
      onHover: ({ object }) => this.hover(object !== undefined),
      getIcon: (d) =>
        this.getIcon(
          d.properties.cluster ? d.properties.point_count : 1,
          d.properties
        ),
      getPosition: (d) => d.geometry.coordinates,
      getSize: (d) =>
        this.getIconSize(d.properties.cluster ? d.properties.point_count : 1),
      getColor: (d) => [Math.sqrt(d.exits), 140, 0],
    }),
    [LAYERS_ID.WAZE_BCN_TRAFFIC_INTENSITY_TEXT_LAYER_GEOJSON]: new TextLayer({
      id: LAYERS_ID.WAZE_BCN_TRAFFIC_INTENSITY_TEXT_LAYER_GEOJSON,
      getText: (d) => this.getText(d),
      getPosition: (d) => d.geometry.coordinates,
      getColor: [0, 0, 0],
      getSize: 16,
      fontWeight: 'bold',
      lineHeight: '1.4',
    }),
  };

  filterUtils = new FilterSQL();

  constructor(
    private city,
    private mvtService: MvtService,
    private filters: any,
    private iconAtlas: string,
    private iconMapping: any
  ) {
    super(LAYERS_ID.WAZE_BCN_TRAFFIC_INTENSITY_LAYER_GEOJSON);
  }

  updateSource() {}

  updateCluster(zoom, force) {
    // Avoid unneccesary request
    if (zoom !== this.zoom || force) {
      this.zoom = zoom;
      const data = this.clusterData(this.data, zoom);

      this.update(LAYERS_ID.WAZE_BCN_TRAFFIC_INTENSITY_POIS_ICONS_LAYER_GEOJSON, {
        data: data,
      });
      this.update(LAYERS_ID.WAZE_BCN_TRAFFIC_INTENSITY_TEXT_LAYER_GEOJSON, {
        data: data,
      });
    }
  }

  getText(d) {
    return d.properties.point_count ? d.properties.point_count.toString() : '';
  }

  clusterData(data, zoom) {
    const index = new Supercluster({
      radius: 60,
      maxZoom: 16,
      initial() {
        return {
          // example: household pets
          level_avg: 0,
        };
      },
      map(properties) {
        return {
          level_avg: properties.alert_level,
        };
      },
      reduce(accumulated, properties) {
        accumulated.level_avg += properties.level_avg;
      },
    });
    const filteredData = data.reduce((pois, poi) => {
      const poiIsVisible = this.filters.type.find(x => x.id === poi.type && x.checked)
      if (poiIsVisible) {
        pois.push(poi)
      }
      return pois;
    }, [])
    index.load(filteredData);
    index.load(
      filteredData.map((d) => ({
        geometry: { coordinates: JSON.parse(d.geojson).coordinates },
        properties: d,
      }))
    );
    // tslint:disable
    return index.getClusters([-180, -85, 180, 85], parseInt(zoom));
    // tslint:enable
  }

  updateState() {}

  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  getDataLayer() {
    const p = [];
    Object.keys(this.layers).forEach((layer_id) => {
      let sql = LAYERS_SQL[layer_id];
      if (this.filters) {
        if (this.filters.fromDate) {
          sql = this.filterUtils.filterQuery(
            LAYERS_SQL[layer_id],
            this.filters
          );
        }
      }
      p.push(this.mvtService.getAPIData(sql).toPromise());
    });
    return Promise.all(p).then(async (values: any) => {
      // TODO: FIX z-index?? To avoid z-index of jam layer added await of 2 seconds
      await this.sleep(2000);
      this.data = values[0].rows;
      const clusterData = this.clusterData(this.data, this.zoom);
      return Object.keys(this.layers).map((id, idx) => ({
        id,
        data: clusterData,
      }));
    }).catch((error) => {

    });
  }

  getName (type) {
    return POI_TYPES.find(x => x.id === type).i18n
  }

  _clickOnPoisLayer(event) {
    const feature = event.object;
    let popup = null;
    let properties: any = {
      type: this.getName(feature.properties.type),
      street:
        !feature.properties.street || feature.properties.street === 'NULL'
          ? ''
          : feature.properties.street,
    };

    popup = HistoricPopupComponent;
    properties = {
      ...properties,
      variable: this.filters.variable.id,
      alert_level: feature.properties.alert_level,
      speed: feature.properties.avg_speed,
      delay: feature.properties.delay,
      length: feature.properties.avg_length,
      level: feature.properties.level
        ? feature.properties.level
        : Math.ceil(
            feature.properties.level_avg / feature.properties.point_count
          ),
      date: this.filters,
      ntram: feature.properties.ntram
    };
    this.openPopup(properties, popup, {
      lng: event.coordinate[0],
      lat: event.coordinate[1],
    });
  }

  getIcon(size, properties) {
    if (size > 1) {
      return this.getIconCluster(properties);
    }
    return this.getPoisLayerIcon(properties);
  }

  getIconCluster(properties) {
    const level = Math.ceil(properties.level_avg / properties.point_count);
    const image = 'cluster-level-' + level;

    return image;
  }

  getPoisLayerIcon(properties) {
    let image = null;
    const iconImage = Object.keys(ICONS_BY_TYPE).find(x => x === properties.type);
    image = ICONS_BY_TYPE[iconImage] + '-' + LEVELS[properties.alert_level];
    if (!image) {
      image = 'jam-low';
    }

    return image.split('/').slice(-1).join().split('.').shift();
  }

  getIconSize(size) {
    return Math.min(100, size) / 100 + 1;
  }
}



// WEBPACK FOOTER //
// ./src/app/historic/layers/clusterTrafficIntensityLayer.ts